export enum CouponsQueryKeys {
  Search = "coupons.search",
  Statement = "coupons.statement",
  History = "coupons.history",
  HistoryPaginated = "coupons.historyPaginated",
  Keyset = "coupons.keyset",
  Trash = "coupons.trash",
  UserHistory = "coupons.userHistory",
  UserHistoryInfinite = "coupons.userHistoryInfinite",
  Single = "coupons.signle",
  UserSingle = "coupons.userSingle",
  Names = "coupons.names",
  LastCoupon = "coupons.lastCoupon",
  WinProbabilityAccuracy = "coupons.winProbabilityAccuracy",
  CashoutOffers = "coupons.cashoutOffers",
}
